export default __webpack_public_path__ + "static/bbq-3-a-cd37832fc735f42a7f04b69660d56a66.webp";